import o from "./index795.js";
import i from "./index855.js";
import m from "./index921.js";
import f from "./index859.js";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};
